export function resolveApiUrl(path) {
  const basePath = process.env.REACT_APP_API_URL || `${window.location.origin}/v1`;
  let prefix;
  try {
    prefix = new URL(basePath).pathname;
  } catch {
    // Handle relative paths
    prefix = basePath;
  }
  if (prefix.endsWith("/")) prefix = prefix.slice(0, -1);

  return new URL(prefix + path, basePath.startsWith("http") ? basePath : window.location.origin);
}
